$(document).ready(function(){
  
    if(window.location.hash){
        let hash = window.location.hash.substring(1); 
        hash = hash.toLowerCase();
        if('creativerewards' == hash){
            if (window.SmileUI) {
                SmileUI.ready().then(smileUiInstance => {
                    SmileUI.openPanel();
                }).catch(err => {
                    console.log(err)
                });
            } else {
                document.addEventListener('smile-ui-loaded', () => {
                    SmileUI.ready().then(smileUiInstance => {
                        SmileUI.openPanel();
                    }).catch(err => {
                        console.log(err)
                    });
                });
            }
        }    
    }
  
    $(document).on('click', '.toggle-box', function(e){
        e.preventDefault();
        $(this).parent().find('.promo').toggleClass('active');
        $(this).parent().find('label').toggleClass('open');
        var x = window.pageXOffset,
        y = window.pageYOffset;
        $(window).one('scroll', function () {
            window.scrollTo(x, y);
        })
      
    });

    $(document).on('focusout', '.has-max-qty',function(){
        $('.max-qty-error').remove();
        let currentQty = parseInt($(this).val());
        let allowQty = parseInt($(this).attr('max'));
        if(currentQty > allowQty){
            $(this).val(allowQty) 
            $(this).parent().next().append(`<div class="max-qty-error"> Only maximum ${allowQty} quantity allowed per order</div>`);
        }
    })

    $(document).on('click', '.list__add-to-cart', function () {
        let currentQty = $('.mini-cart-item[data-variant="'+$(this).attr('data-variant-id')+'"] .mini-cart-item-quantity span').html();
        let maxQuantityAllowed = $(this).attr('data-max-qty');
        
        if( maxQuantityAllowed && currentQty >= maxQuantityAllowed){
            $(this).parent().append(`<div>Only maximum ${maxQuantityAllowed} quantity allowed per order</div>`)
            $(this).remove();
            return ;
        }
        $(this).val('Adding...');
        const formData = new FormData();
        formData.append('quantity',1);
        formData.append('id',$(this).attr('data-variant-id'));
        formData.append('product-id',$(this).attr('data-product-id'));
        formData.append('form_type','product');
        fetch(`${window.Theme.routes.cart_add_url}.js`, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(response => {
            if (!response.ok) {
                const error = new Error();
                error.response = response;
                throw error;
            }
            return response.json();
        }).then(item => {
            if (!item) return;
            $(this).val('Added');
            setInterval(() => {
                $(this).val('Add To Cart');
            }, 2000);
             
            fetch('/?sections=mini-ajax')
            .then(response=>response.json())
            .then(el=>{
                el = el['mini-ajax'];
                var dataEls = $(el).find('[data-data]');
                var newData = {};
      
                if (dataEls.length === 1 && dataEls[0].getAttribute('data-data') === '') {
                  newData = JSON.parse(dataEls[0].innerHTML);
                } else {
                  for (var _i = 0; _i < dataEls.length; _i++) {
                    newData[dataEls[_i].getAttribute('data-data')] = JSON.parse(dataEls[_i].innerHTML);
                  }
                }
                var htmlEls = $(el).find('[data-html]');
                var newHtml = {};
      
                if (htmlEls.length === 1 && htmlEls[0].getAttribute('data-html') === '') {
                  newHtml = htmlEls[0].innerHTML;
                } else {
                  for (var i = 0; i < htmlEls.length; i++) {
                    newHtml[htmlEls[i].getAttribute('data-html')] = htmlEls[i].innerHTML;
                  }
                }
                const cartCount = document.querySelector('.cart-count-number');
                cartCount.innerText = newData.itemCount;
                $('.mini-cart-wrapper .mini-cart').remove();
                $('.mini-cart-wrapper').append(newHtml['miniCart']);
            });
            
        }).catch(error => console.log(error));
    })
})